import React from 'react';

import { InvalidFieldsProps } from 'types';
import Button from 'components/Button/Button';
import { formatListOfNames, listAppsInString } from 'utils';
import Icon from 'icons/ic_ErrorInfo.svg';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const InvalidFields: React.FC<InvalidFieldsProps & ComponentProps> = (props) => {
  const { styles, closeModal } = props;
  const [title, body] = (() => {
    const { type } = props;
    if (type === 'INVALID_FIELDS_SINGLE_MENU_PUBLISH') {
      const { items, publish } = props;
      return [
        `We can't ${publish ? 'publish' : 'save'} your changes`,
        `Please enter a valid price for ${formatListOfNames(items)}`
      ];
    }
    const { affectedApps, hasBrands, venueName } = props;
    return [
      `We can't save your changes`,
      `Please enter a valid price for ${listAppsInString(affectedApps, hasBrands, venueName)}`
    ];
  })();

  return (
    <div
      data-testid="invalid-fields"
      role="dialog"
      aria-labelledby="invalid-fields-title"
      aria-describedby="invalid-fields-description"
    >
      <img src={Icon} alt="Error" />
      <h2 id="invalid-fields-title" className={styles.NoMargin}>
        {title}
      </h2>
      <p id="invalid-fields-description" data-testid="invalid-fields-copy">
        {body}
      </p>
      <div className={`${styles.ButtonRow} ${styles.Single}`}>
        <Button onClick={closeModal}>
          <span>Ok</span>
        </Button>
      </div>
    </div>
  );
};

export default InvalidFields;
